import '@babel/polyfill';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import Foundation from 'foundation-sites';
import Swiper from '../../node_modules/swiper/dist/js/swiper.js';
import Headhesive from 'headhesive';
import LazyLoad from 'vanilla-lazyload';

svg4everybody();

window.$ = $;
window.jQuery = $;

Foundation.addToJquery($);
window.Swiper = Swiper;
window.Headhesive = Headhesive;
window.LazyLoad = LazyLoad;

require('ninelines-ua-parser');
require('@fancyapps/fancybox');
require('slick-carousel');
require('jquery.scrollto');
require('jquery-validation');
// require('vanilla-lazyload');
// require('headhesive');
